<template>
  <div>
    <q-no-ssr>
      <Bus/>
      <StackModal namespace="modal"/>
      <DebugPanelButton/>
    </q-no-ssr>
    <router-view/>
  </div>
</template>

<script setup lang="ts">
import Bus from "@/components/Bus.vue";
import {useBus} from "@/core/store/bus";
import {useDebugStore} from '@/core/store/debug';
import StackModal from "@/packages/stack-router/components/StackModal.vue";
import DebugPanelButton from "@/pages/debug/DebugPanelButton.vue";
import {buildCanonicalUrl} from "@/core/util/canonicalUrl";
import {QNoSsr, useMeta} from "quasar";
import {onMounted} from "vue";
import {RouterView, useRoute} from "vue-router";

const route = useRoute()

// Запасной title для SSR-страниц без своего useMeta.
// Совпадает с productName в package.json: в SSR этот тег из index.html не попадает в HTML,
// иначе Quasar дописывает второй <title> из useMeta и не удаляет шаблонный.
useMeta(() => ({
  title: "Суши-Cтудио | Доставка роллов в Иркутске",
  link: {
    canonical: {
      rel: "canonical",
      href: buildCanonicalUrl(route),
    },
  },
}));

onMounted(() => {
  //if (typeof window !== undefined && window.hidePreloader) window.hidePreloader()
  if (!process.env.SERVER) {
    let scrollHandler: (() => void) | null = null

    const removeClass = () => {
      document.body.classList.remove('body-initial')
      if (scrollHandler)
        window.removeEventListener('scroll', scrollHandler)
      scrollHandler = null
    }

    scrollHandler = () => {
      // Проверяем что скролл больше 300px
      if (window.scrollY > 100) {
        setTimeout(removeClass, 500)
      }
    }

    setTimeout(removeClass, 2000)

    window.addEventListener('scroll', scrollHandler, {passive: true})
  }
})

const debugStore = useDebugStore()
debugStore.enableComponentDebug()

const {bus} = useBus()

bus.on('scopes:fetched', (scopes, scopesMap) => {

});


</script>
